module.exports = __webpack_public_path__ + "img/018-postman.beeb8c77.png";